import React from 'react';
import { motion } from "motion/react";

interface SendCodeButtonProps {
  onClick: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  cooldownSeconds?: number;
}

export const SendCodeButton: React.FC<SendCodeButtonProps> = ({
  onClick,
  isLoading,
  isDisabled,
  cooldownSeconds = 0
}) => {
  const buttonVariants = {
    hover: { scale: 1.02 },
    tap: { scale: 0.98 },
    disabled: { scale: 1, opacity: 0.5 }
  };

  const getButtonText = () => {
    if (isLoading) return 'Sending...';
    if (cooldownSeconds > 0) return `Resend in ${cooldownSeconds}s`;
    return 'Send Code';
  };

  return (
    <motion.button
      type="button"
      onClick={onClick}
      disabled={isDisabled || isLoading || cooldownSeconds > 0}
      className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
      variants={buttonVariants}
      whileHover={!isDisabled && !isLoading && cooldownSeconds === 0 ? "hover" : "disabled"}
      whileTap={!isDisabled && !isLoading && cooldownSeconds === 0 ? "tap" : "disabled"}
    >
      <span className="flex items-center gap-2">
        {isLoading && (
          <motion.div 
            className="w-3 h-3 border-2 border-white border-t-transparent rounded-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
        )}
        {getButtonText()}
      </span>
    </motion.button>
  );
};

